(function() {
  function initJoeCountdown() {
    const dayElement = document.getElementById('joe-shipping-day');
    if (!dayElement) return;

    const cutoffHour = 13; // Deadline 13 Uhr

    // --- LOGIK TEIL (Bleibt präzise) ---

    function getDispatchDate(now) {
      const currentHour = now.getHours();
      const currentDay = now.getDay(); // 0=So, 1=Mo, ... 6=Sa
      
      let dispatchDate = new Date(now);

      // 1. Montag (1) -> geht Dienstag raus
      if (currentDay === 1) {
        dispatchDate.setDate(now.getDate() + 1); 
      }
      // 2. Wochenende: Sa(6) oder So(0) -> geht Dienstag raus
      else if (currentDay === 6) {
        dispatchDate.setDate(now.getDate() + 3); 
      } else if (currentDay === 0) {
        dispatchDate.setDate(now.getDate() + 2);
      }
      // 3. Freitag (5) nach 13 Uhr -> geht Dienstag raus
      else if (currentDay === 5 && currentHour >= cutoffHour) {
        dispatchDate.setDate(now.getDate() + 4);
      }
      // 4. Di-Do nach 13 Uhr -> geht morgen raus
      else if ((currentDay >= 2 && currentDay <= 4) && currentHour >= cutoffHour) {
        dispatchDate.setDate(now.getDate() + 1);
      }
      
      dispatchDate.setHours(cutoffHour, 0, 0, 0);
      return dispatchDate;
    }

    function getDeliveryDate(now) {
      const dispatchDate = getDispatchDate(now);
      const deliveryDate = new Date(dispatchDate);

      // 2 Tage Laufzeit
      deliveryDate.setDate(dispatchDate.getDate() + 2);

      // Sonntags keine Zustellung -> Montag
      if (deliveryDate.getDay() === 0) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
      }

      return deliveryDate;
    }

    function getTimeRemaining(now) {
      const dispatchDate = getDispatchDate(now);
      const diffMs = dispatchDate - now;
      if (diffMs < 0) return 0;
      return Math.floor(diffMs / 60000); // Minuten
    }

    function formatTime(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours} Std. ${minutes.toString().padStart(2, '0')} Min.`;
    }

    // --- ANZEIGE TEIL (Angepasst für Marketing) ---

    function updateCountdown() {
      const now = new Date();
      // Joe's Roast, vorübergehend: vom Weihnachts-Bestellschluss (Do 17.12.2026, 12:00) bis Heiligabend (24.12.2026, 23:59) kein Lieferdatum. Danach von selbst wieder wie bisher.
      if (now >= new Date('2026-12-17T12:00:00+01:00') && now < new Date('2026-12-25T00:00:00+01:00')) {
        dayElement.innerHTML = 'Wir schicken deine Bestellung so schnell wie möglich los.<br>Die Lieferung vor Heiligabend können wir aber nicht mehr zusagen.';
        return;
      }
      const remainingMinutes = getTimeRemaining(now);
      const deliveryDate = getDeliveryDate(now);

      const formattedDeliveryDate = deliveryDate.toLocaleDateString('de-DE', {
        weekday: 'long',
        day: 'numeric',
        month: 'long' 
      });

      // HTML zusammenbauen
      let deliveryHtml = `Lieferung bis <strong>${formattedDeliveryDate}</strong>.`;
      let urgencyHtml = '';

      // DER SMART SWITCH:
      // Wenn weniger als 4 Stunden (240 Min) übrig sind UND wir am selben Tag versenden würden:
      // Zeigen wir den echten Timer. Ansonsten den Marketing-Text.
      
      const hoursUntilCutoff = remainingMinutes / 60;
      
      // Wir prüfen, ob "heute" auch wirklich der Versandtag ist (indem wir prüfen, ob Diff < 24h)
      // und ob es knapp wird (< 4 Std).
      if (hoursUntilCutoff < 4 && hoursUntilCutoff > 0) {
         // ECHTER TIMER (z.B. Dienstag 11:30 Uhr)
         urgencyHtml = `<br>Bestelle innerhalb von <span class="countdown-time" style="color:#d32f2f;">${formatTime(remainingMinutes)}</span>`;
      } else {
         // MARKETING TEXT (Wochenende, Montag oder Abends)
         // Hier nutzen wir deine gewünschte Formulierung, um die lange Wartezeit zu kaschieren.
         urgencyHtml = `<br>wenn du innerhalb der <span style="color:#d32f2f;">nächsten Stunde</span> bestellst.`;
      }

      dayElement.innerHTML = deliveryHtml + urgencyHtml;
    }

    updateCountdown();
    if (!window.joeCountdownInterval) {
        window.joeCountdownInterval = setInterval(updateCountdown, 10000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJoeCountdown);
  } else {
    initJoeCountdown();
  }
  
  document.addEventListener('shopify:section:load', initJoeCountdown);
  document.addEventListener('shopify:block:select', initJoeCountdown);

})();